<template>
  <div class="RMCShowSingleResult">
    <div class="RMCShowSingleResultTitle">
      {{ roundData.name }}
    </div>
    <div class="iconClose-Corner">
      <CrossWhiteIcon @click="closePopover"/>
    </div>
    <div class="RMCShowSingleResultDate"> {{ $t('no.') }} {{ roundData.round }}</div>
    <div class="RMCShowSingleResultDate">{{ roundData.createdDate }}</div>
    <div class="RMCShowSingleResult-container-content">
      <div class="RMCShowSingleResult-container-top RMCShowSingleResult-Lottery-XD-Top">
        <div class="RMCShowSingleResult-Lottery-container-dice">
          <img :src="classDice1">
          <img :src="classDice2">
          <img :src="classDice3">
        </div>
      </div>
      <div class="result-hline RMCShowSingleResult-hLine"></div>
      <div class="RMCShowSingleResult-Lottery-XD-Bottom RMCShowSingleResult-container-bottom">
        <div class="RMCShowSingleResult-Lottery-XD-Sum">
          <div class="RMCShowSingleResult-lottery-container-sum">
            <div class="RMCShowSingleResult-sum-total fr-main-txt">Tổng</div>
            <div class="RMCShowSingleResult-sum-value">
              {{ roundData.score.total }}
            </div>
          </div>
          <div class="result-vline-thin RMCShowSingleResult-lottery-vline"></div>
          <div class="result-box fr-main-bg RMCShowSingleResult-lottery-sum-score">
            {{ getBigSmall }}
          </div>
          <!-- <div class="result-box fr-main-bg RMCShowSingleResult-lottery-sum-score">
            {{ getOddEven }}
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CrossWhiteIcon from '@assets/icons/cross-white.svg';

export default {
  components: {
    CrossWhiteIcon,
  },
  props: {
    roundData: {
      type: Object,
      default: () => ({
        name: { type: String, default: "" },
        value: { type: String, default: "" },
        round: { type: Number, default: 0 },
        score: { type: Object, default: () => ({})},
        createdDate: { type: String, default: "" },
      })
    },
  },
  data() {
    return {

    }
  },
  computed: {
    classDice1: function () {
      return `/images/dice${this.roundData.score.first.value}.png`;
    },
    classDice2: function () {
      return `/images/dice${this.roundData.score.second.value}.png`;
    },
    classDice3: function () {
      return `/images/dice${this.roundData.score.third.value}.png`;
    },
    getOddEven: function (val) {
      return this.roundData.score.oddEven === "ODD" ? "Lẻ" : "Chẳn";
    },
    getBigSmall: function (val) {
      // if(this.roundData.score.anyX3) return "Mọi cược ba";
      return this.roundData.score.bigSmall === "BIG" ? "Tài" : "Xỉu";
    }
  },
  mounted() {
    // this.popoverOptions.popoverReference = this.$refs.popoverReference;
  },
  methods: {
    closePopover() {
      // console.log('TaiXiuResult - closePopover')
      this.$emit('closePopover');
    },
  }
}
</script>

<style>

</style>
